var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Status"}},[_c('input-radio-multi',{attrs:{"name":"listing_status","value":_vm.listing_detail.listing_status,"options":[
            { label: 'New', value: 'new' },
            { label: 'Contingent', value: 'contingent' },
            { label: 'Cancel', value: 'cancel' },
            { label: 'Expired', value: 'expired' },
        ],"nullable":true,"group_class":"flex-wrap","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }